import { useGame } from "@/contexts/GameContext";
import { Check } from "lucide-react";
import { themes } from "@/lib/constants";
import { motion } from "framer-motion";
import { Button } from "../ui/button";
import { cn } from "@/lib/utils";

export default function ThemesStep() {
  const { state, dispatch } = useGame();
  const currentThemes = state.settings?.themes || [];

  const toggleTheme = (themeId) => {
    const newThemes = currentThemes.includes(themeId)
      ? currentThemes.filter((t) => t !== themeId)
      : [...currentThemes, themeId];

    dispatch({ type: "UPDATE_SETTINGS", payload: { themes: newThemes } });
  };

  return (
    <div className="space-y-4">
      <div className="grid sm:grid-cols-2 gap-4">
        {themes.map((theme) => {
          const Icon = theme.icon;
          const isSelected = currentThemes.includes(theme.id);

          return (
            <Button
              key={theme.id}
              onClick={() => toggleTheme(theme.id)}
              size="lg"
              variant="outline"
              className={cn(
                "whitespace-normal relative bg-card/60 backdrop-blur-sm h-auto p-3 rounded-xl outline transition-all duration-200 flex items-center text-left gap-2",
                isSelected ? "outline-primary/50" : "outline-none"
              )}
            >
              {/* Ikona - mniejsza */}
              <div
                className={`
                w-8 h-8 rounded-lg flex items-center justify-center mr-3 flex-shrink-0 transition-colors
                ${
                  isSelected
                    ? "bg-primary/80"
                    : "bg-primary/60 group-hover:bg-primary/50"
                }
            `}
              >
                <Icon className="w-4 h-4 text-white" />
              </div>

              {/* Nazwa i opis - kompaktowe */}
              <div className="flex-1">
                <div className="font-semibold text-base">{theme.name}</div>
                <div className="text-xs">{theme.description}</div>
              </div>

              {/* Wskaźnik zaznaczenia */}
              {isSelected && (
                <motion.div
                  initial={{ scale: 0.5, opacity: 0 }}
                  animate={{ scale: 1, opacity: 1 }}
                  className="absolute z-10 top-2 right-2 w-5 h-5 bg-primary rounded-full flex items-center justify-center"
                >
                  <Check className="w-3 h-3 text-white" />
                </motion.div>
              )}
            </Button>
          );
        })}
      </div>
      {currentThemes.length === 0 && (
        <div className="text-center mt-4">
          <p className="text-sm text-yellow-600 dark:text-yellow-400">
            Wybierz przynajmniej jeden motyw aby rozpocząć grę.
          </p>
        </div>
      )}
    </div>
  );
}
